import PaymentKioskConnectionWarning from './PaymentKioskConnectionWarning.jsx';

export default PaymentKioskConnectionWarning;


// WEBPACK FOOTER //
// ./src/components/PaymentKioskConnectionWarning/index.js